module.exports = __webpack_public_path__ + "img/debtPayingAbility10.8266a06b.png";